import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../store/useAuthStore';
import toast from 'react-hot-toast';

export const useAutoLogout = (timeoutMinutes = 1440) => {
  const { logout } = useAuthStore();
  const navigate = useNavigate();
  const timerRef = useRef(null);

  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    
    timerRef.current = setTimeout(() => {
      toast.info('Session expired due to inactivity. Please login again.');
      logout();
      navigate('/login');
    }, timeoutMinutes * 60 * 1000); // Convert minutes to milliseconds
  };

  useEffect(() => {
    // Reset timer on user activity
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
    
    events.forEach(event => {
      document.addEventListener(event, resetTimer, true);
    });

    // Start the timer
    resetTimer();

    // Cleanup
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      events.forEach(event => {
        document.removeEventListener(event, resetTimer, true);
      });
    };
  }, [timeoutMinutes, logout, navigate]);

  // Function to manually reset the timer (useful for explicit user actions)
  const refreshSession = () => {
    resetTimer();
  };

  return { refreshSession };
};
